import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Customers from './pages/Customers';
import Orders from './pages/Orders';
import Inventory from './pages/Inventory';
import Products from './pages/Products';
import Payments from './pages/Payments';
import Users from './pages/Users';
import Tasks from './pages/Tasks';
import Production from './pages/Production';
import SystemLog from './pages/SystemLog';
import Import from './pages/Import';
import Reports from './pages/Reports';
import BOM from './pages/BOM';
import Shipments from './pages/Shipments';
import Suppliers from './pages/Suppliers';
import FinishedInventory from './pages/FinishedInventory';

function ProtectedRoute({ children, roles }) {
  const { token, user } = useAuth();
  if (!token) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user?.role)) return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  const { token } = useAuth();
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={!token ? <Login /> : <Navigate to="/" replace />} />
        <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<Dashboard />} />
          <Route path="customers" element={<ProtectedRoute roles={['admin','sales_manager','sales_employee']}><Customers /></ProtectedRoute>} />
          <Route path="orders" element={<ProtectedRoute roles={['admin','sales_manager','sales_employee']}><Orders /></ProtectedRoute>} />
          <Route path="payments" element={<ProtectedRoute roles={['admin','sales_manager']}><Payments /></ProtectedRoute>} />
          <Route path="inventory" element={<ProtectedRoute roles={['admin','sales_manager','warehouse']}><Inventory /></ProtectedRoute>} />
          <Route path="products" element={<ProtectedRoute roles={['admin','sales_manager','warehouse']}><Products /></ProtectedRoute>} />
          <Route path="production" element={<ProtectedRoute roles={['admin','sales_manager','production_manager']}><Production /></ProtectedRoute>} />
          <Route path="bom" element={<ProtectedRoute roles={['admin','sales_manager']}><BOM /></ProtectedRoute>} />
          <Route path="tasks" element={<ProtectedRoute roles={['admin','sales_manager','sales_employee']}><Tasks /></ProtectedRoute>} />
          <Route path="reports" element={<ProtectedRoute roles={['admin','sales_manager']}><Reports /></ProtectedRoute>} />
          <Route path="shipments" element={<ProtectedRoute roles={['admin','sales_manager','sales_employee']}><Shipments /></ProtectedRoute>} />
          <Route path="users" element={<ProtectedRoute roles={['admin']}><Users /></ProtectedRoute>} />
          <Route path="logs" element={<ProtectedRoute roles={['admin','sales_manager']}><SystemLog /></ProtectedRoute>} />
          <Route path="import" element={<ProtectedRoute roles={['admin']}><Import /></ProtectedRoute>} />
          <Route path="suppliers" element={<ProtectedRoute roles={['admin','sales_manager','warehouse']}><Suppliers /></ProtectedRoute>} />
          <Route path="finished-inventory" element={<ProtectedRoute roles={['admin','sales_manager','warehouse','production_manager']}><FinishedInventory /></ProtectedRoute>} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default function App() {
  return <AuthProvider><AppRoutes /></AuthProvider>;
}
